import React from 'react';

import styles from './weCheckboxInput.module.css';

const Container = ({ children }) => {
    return (
        <div className={`${styles.container}`}>
            {children}
        </div>
    )
}

const Input = ({ id,isChecked,action,index }) => {
    return (
        <label className={styles.input_wrapper} htmlFor={id} title="Add license">
            <input
                type="checkbox"
                tabIndex="0"
                id={id}
                checked={isChecked}
                onChange={action}
                data-value={index}                
            />
            <span className={styles.checkmark}></span> 
        </label>
    )
}


function WECheckboxInput({ id,isChecked,action,index,...props }) {
    return (
        <Container>
            <Input id={id} isChecked={isChecked} action={action} index={index} {...props} />
        </Container>
    );
}

export default WECheckboxInput;